module.exports = __webpack_public_path__ + "static/media/mai6.eea112d7.jpg";